import { LENGTH } from './messages';

const lengthValidation = (fields, key, criteria) => {
  const field = fields[key];
  const message = criteria.message || LENGTH;
  return field.length < criteria.value ? message : null;
};
export default lengthValidation;
